import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable } from "mobx";

class Attribute {
  constructor(
    id = uuidv4(),
    name = "",
    title = "",
    subtitle = "",
    order = 0,
    isPredefined = false,
    isSelected = false,
    predefinedExercise = null,
    exercise = null
  ) {
    this.id = id;
    this.name = name;
    this.title = title;
    this.subtitle = subtitle;
    this.order = order;
    this.isPredefined = isPredefined;
    this.isSelected = isSelected;
    this.predefinedExercise = predefinedExercise;
    this.exercise = exercise;
    makeAutoObservable(this);
  }

  // #region /* PREDEFINED ATTRIBUTES */
  setIsSelected(newValue) {
    this.isSelected = newValue;
  }

  duplicate(exercise) {
    return new Attribute(
      undefined,
      this.name,
      this.title,
      this.subtitle,
      this.order,
      false,
      false,
      null,
      exercise
    );
  }
  // #endregion

  // #region /* REAL-TIME */
  updateAttribute(attribute) {
    this.isPredefined = attribute.is_predefined ?? false;
    this.name = attribute.name ?? "";
    this.title = attribute.title ?? "";
    this.order = attribute.order ?? 0;
    this.subtitle = attribute.subtitle ?? "";
  }

  uploadToCloud() {
    return {
      id: this.id.toString().toLowerCase(),
      name: this.name,
      title: this.title,
      order: this.order,
      subtitle: this.subtitle,
    };
  }
  // #endregion

  static AttributeTitles = {
    equipment: "equipment-string",
    tempo: "tempo-string",
    rom: "rom-string",
    stanceGrip: "stanceGrip-string",
    loadAccomodation: "loadAccomodation-string",
    accessories: "accessories-string",
    other: "other-string",
  };
}
export default Attribute;
